import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

class CareersTextHero {
  constructor(component) {
    this.refs = {
      link: '.js-link',
    };

    this.dom = {
      $component: component,
      $links: component.querySelectorAll(this.refs.link),
    };

    this.state = {
    };

    this.init();

    this.mount();
  }

  init() {
    const { dom } = this;
    
    gsap.registerPlugin(ScrollToPlugin);
  }

  mount() {
    const { dom } = this;

    if (!dom.$links) return;

    dom.$links.forEach($link => {
      $link.addEventListener('click', this.handleLinkClick.bind(this));
    });
  };

  handleLinkClick(e) {
    const { dom } = this;
    e.preventDefault();
    e.stopPropagation();

    // if link contains #, get the id of the anchor and scroll to that element
    const $link = e.currentTarget;
    const href = $link.getAttribute('href');
    const anchorIndex = href.indexOf('#');

    if (anchorIndex === -1) { 
      window.location = href;
      return;
    };

    const anchorId = href.substring(anchorIndex + 1);
    const $targetElement = document.getElementById(anchorId);

    if ($targetElement) {
      e.preventDefault();
      gsap.to(window, { 
        duration: 1, 
        scrollTo: { y: $targetElement.offsetTop - 65, autoKill: true },
        onComplete: () => {
          $targetElement.focus({ preventScroll: true });
        },
      });
    }
  }
}

const $careersTextHero = document.querySelector('.js-careers-text-hero');
if ($careersTextHero) new CareersTextHero($careersTextHero);